import './style.scss';
import { useTranslation } from 'react-i18next';
import { EventItem } from 'queries/events/types';
import ExpandText from 'components/ExpandText/ExpandText';
import { useMemo } from 'react';
import { useEventQuery } from 'queries/events';
import { ChartsArea } from '../ChartsArea';
import EventTitle from '../EvenTitle/EventTitle';
import EventFooter from './components/EventFooter/EventFooter';
import SimilarEvent from './components/SimilarEvent/SimilarEvent';
import { useChartTabs } from '../ChartsArea/hooks/useChartTabs';
import { getAlarmsInfoFromEvent } from '../ChartsArea/helpers';
import EventInfo from '../EventInfo/EventInfo';
import MarkdownFormattedText from 'components/MarkdownFormattedText/MarkdownFormattedText';

type EventDetailsProps = {
  selectedRow: EventItem;
  setSelectedRow?: (row?: EventItem) => void;
  assetId: string;
};

const EventDetails = ({ selectedRow, setSelectedRow, assetId }: EventDetailsProps) => {
  const { t } = useTranslation();
  const { data } = useEventQuery(
    { eventId: selectedRow.id },
    {
      enabled: !!selectedRow.id,
    },
  );
  const eventWithModel = { ...selectedRow, model_name: data?.data.model_name };
  const { chartsNames } = useChartTabs({ event: eventWithModel });
  const alarmsInfo = useMemo(() => getAlarmsInfoFromEvent(selectedRow), [selectedRow.id]);

  if (!selectedRow) {
    return null;
  }

  return (
    <div className="event-side-detail">
      <EventTitle event={selectedRow} showExpandButton />
      <div className="event-side-detail-scroll">
        <div className="details-wrapper">
          <EventInfo event={selectedRow} />
          <div className="event-detail-expands">
            {selectedRow?.prognosis && (
              <ExpandText
                text={
                  !selectedRow?.prognosis || selectedRow.prognosis === '-' ? (
                    t('event_page:no_prognosis')
                  ) : (
                    <MarkdownFormattedText
                      className="prognosis-markdown"
                      text={selectedRow.prognosis}
                    />
                  )
                }
                rows={2}
              />
            )}
            <SimilarEvent eventId={selectedRow.id} assetId={assetId} />
          </div>
          <ChartsArea
            assetId={assetId}
            selectedRow={eventWithModel}
            tabs={chartsNames}
            alarmsInfo={alarmsInfo}
            showTitle={false}
          />
        </div>
      </div>

      <EventFooter event={selectedRow} setSelectedRow={setSelectedRow} />
    </div>
  );
};

export default EventDetails;
